package io.horion.cv.components.cards

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import io.horion.cv.utils.Colors
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.widgets.ColonneInfo
import io.horion.cv.styles.InteractiveElementStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Text


@Composable
fun JobCardNew(
    isUser: Boolean  = true,
    job: io.horion.cv.models.Job,
    isOpen: Boolean,
    breakpoint: Breakpoint,
    onClick: () -> Unit,
    isDark: Boolean
) {

    val ctx = rememberPageContext()
    // État local pour le favori
    var isFavorite by remember { mutableStateOf(false) }
    var isHovered by remember { mutableStateOf(false) }
    val borderColor = when {
        isHovered && isDark -> Colors.White
        isHovered && !isDark -> Colors.Black
        isDark -> Colors.HalfBlack
        else -> Colors.LightGray
    }
    Column(
        modifier = InteractiveElementStyle.toModifier()
            .fillMaxWidth()
            .backgroundColor(if (isDark) org.jetbrains.compose.web.css.Color.transparent else Colors.White)
            .margin(topBottom = if (breakpoint >= Breakpoint.MD) 20.px else 15.px)
            .borderRadius(12.px)
            .padding(if (breakpoint >= Breakpoint.MD) 20.px else 10.px)
            .cursor(Cursor.Pointer)
            .onMouseEnter { isHovered = true }
            .onMouseLeave { isHovered = false }
            .border(1.px, LineStyle.Solid, borderColor)
            .onClick { onClick() }
    ) {
        val iconFilter = if (isDark) "invert(1)" else "none"

        // 🔹 TOP ROW
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {

            // IMAGE
            if (isUser){
                Image(
                    src = "/mtn.png",
                    alt = "company",
                    modifier = Modifier
                        .size(if (breakpoint >= Breakpoint.MD) 40.px else 25.px)
                        .borderRadius(10.px)
                        .objectFit(ObjectFit.Cover)
                        .border(1.px,LineStyle.Solid, Colors.White)
                )
            }

            // TEXT INFOS
            Column(
                modifier = Modifier
                    .margin(left = 15.px)
                    .flexGrow(1)
            ) {

                SpanText(
                    job.title,
                    modifier = Modifier
                        .fontSize(if (breakpoint >= Breakpoint.MD) 20.px else 18.px)
                        .fontWeight(FontWeight.Bold)
                        .color(if (isDark) Colors.White else Colors.Black)
                )
                //NOM DE LENTREPRISE ET DATE DE PUBLICATION
                if (isUser){
                    SpanText(
                        "${job.enterprise} • ${job.publicateAt}",
                        modifier = Modifier
                            .fontSize(if (breakpoint >= Breakpoint.MD) 14.px else 12.px)
                            .color(if (isDark) Colors.White else Colors.Graytext)
                            .margin(top = 5.px)
                    )
                }
            }

            // ICONS (fav + arrow)
            Row(
                horizontalArrangement = Arrangement.spacedBy(10.px),
                verticalAlignment = Alignment.CenterVertically
            ) {

                // ICÔNE FAVORI - CHANGE EN FONCTION DE L'ÉTAT
                if (isUser) {
                    Image(
                        src = if (isFavorite) "/favChecked.svg" else "/fav.svg",
                        description = "favorite",
                        modifier = Modifier
                            .size(20.px)
                            .cursor(Cursor.Pointer)
                            .onClick {
                                it.stopPropagation()
                                isFavorite = !isFavorite
                            }
                            .styleModifier { property("filter", iconFilter) }

                    )

                }else{

                    if (breakpoint >= Breakpoint.MD) {
                        Button(
                            attrs = Modifier
                                .cursor(Cursor.Pointer)
                                .toAttrs {
                                    classes("btn", "btn-outline-primary")
                                    onClick {e->
                                        e.stopPropagation()
                                        ctx.router.navigateTo("/job/candidatures?id=${job.id}")
                                    }
                                }
                        ) {
                            Text("voir les candidatures" )
                        }
                    }
                }
            }
        }

        //  SEPARATOR
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(Colors.LightGray)
                .margin(topBottom = 15.px)
        )

        //  DESCRIPTION
        SpanText(
            if (isOpen) job.description
            else job.description.take(120) + "...",
            modifier = Modifier
                .fontSize(16.px)
                .color(if (isDark) Colors.White else Colors.Black)
        )

        //  COLONNE INFO (VISIBLE SI OPEN)

        Column(
            modifier = Modifier.margin(top = 15.px)
        ) {
            //vertical = !isOpen
            ColonneInfo(
                job = job,
                breakpoint = breakpoint,
                isDark = isDark
            )
        }

    }
}
